module.exports = __webpack_public_path__ + "img/assay.724e32dd.svg";